import {useUpmPlantNow} from '@hconnect/upm'
import {TextField} from '@mui/material'
import {LocalizationProvider, TimePicker} from '@mui/x-date-pickers'
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {Moment} from 'moment-timezone'

import {useUrlParam} from '../../../shared/hooks/useUrlParam'

interface OptimizerSettingsTimePickerProps {
  label: string
  errorMessage?: string
  value: Moment
  setValue: (value: Moment | null) => void
  'data-test-id'?: string
}

export const OptimizerSettingsTimePicker: React.FC<OptimizerSettingsTimePickerProps> = ({
  label,
  errorMessage,
  value,
  setValue,
  'data-test-id': testId
}) => {
  const plantCode = useUrlParam('plantCode')
  const getPlantNow = useUpmPlantNow(plantCode)

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TimePicker
        label={label}
        value={value}
        views={['hours']}
        onChange={(value) => {
          setValue(value !== null ? value.clone().minute(0) : getPlantNow().minute(0))
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="filled"
            size="small"
            error={!!errorMessage}
            helperText={errorMessage}
            sx={({spacing}) => ({
              width: spacing(30),
              backgroundColor: 'transparent',
              '& .MuiFilledInput-root': {
                backgroundColor: 'transparent',
                height: spacing(6),
                borderRadius: spacing(0.5)
              },
              '& .MuiFilledInput-root:hover': {
                backgroundColor: 'transparent'
              }
            })}
            data-test-id={testId}
          />
        )}
      />
    </LocalizationProvider>
  )
}
